import type {RiskAssessmentCodeResponse} from 'src/api/ProactApiClient';
import type {PillProps} from 'src/design/atoms/Pill';
import type {ISelectOption} from 'src/types/Form';
import type {IFormFieldV2} from 'src/types/FormV2';

export const InstanceComplianceStandardFormMeta = (
  departments?: ISelectOption[],
  riskAsset?: RiskAssessmentCodeResponse
): IFormFieldV2[] => {
  let probabilityOptions: ISelectOption[] = [];
  let severityOptions: ISelectOption[] = [];

  if (riskAsset) {
    probabilityOptions = Object.values(riskAsset.probability as any).map(
      (val, index) => {
        return {label: `${index + 1} - ${val}`, id: index + 1};
      }
    );
    severityOptions = Object.values(riskAsset.severity as any).map(
      (val, index) => {
        return {label: `${index + 1} - ${val}`, id: index + 1};
      }
    );
  }

  return [
    {
      name: 'titleNumberLabel',
      label: 'Title',
      type: 'text',
      readOnly: true,
    },
    {
      name: 'issuedAt',
      label: 'Last Issued Date',
      type: 'date',
      readOnly: true,
    },
    {
      name: 'content',
      label: 'Content',
      type: 'richtext',
      readOnly: true,
    },
    {
      name: 'active',
      label: 'Active',
      type: 'switch',
      required: true,
      switchOptions: {
        positiveText: 'Yes',
        negativeText: 'No',
      },
    },
    {
      name: 'departmentIds',
      label: 'Associated Department(s)',
      type: 'select-multiple',
      required: true,
      options: departments,
    },
    {
      name: 'summary',
      label: 'Summary',
      type: 'textarea',
      validation: {
        maxLength: 500,
      },
    },
    {
      name: 'note',
      label: 'Notes',
      type: 'richtext',
    },
    {
      name: 'files',
      label: 'Files',
      type: 'file',
    },
    {
      name: 'riskAssessmentProbability',
      label: 'Risk Probability',
      type: 'select',
      options: probabilityOptions || [],
    },
    {
      name: 'riskAssessmentSeverity',
      label: 'Risk Severity',
      type: 'select',
      options: severityOptions || [],
    },
    {
      name: 'riskScore',
      label: 'Risk Score',
      type: 'text',
      readOnly: true,
    },
  ];
};

export const InstanceComplianceStandardPillConfig = (
  active?: boolean
): PillProps[] => {
  switch (active) {
    case true:
      return [{text: 'Active', color: 'green'}];
    case false:
      return [{text: 'Inactive', color: 'gray'}];
    default:
      break;
  }
  return [];
};

export const InstanceComplianceStandardDocumentTitle = 'Compliance Standards';
